import { v4 as uuid } from 'uuid'
import { IPriceListEntry, PriceListEntry } from './PriceListEntry/PriceListEntry'

export interface IPriceList {
  id: string
  vendorCompanyId: string
  vendorRepName: string
  vendorCompanyName: string
  restaurantCompanyId: string
  vendorRepEmail: string
  vendorRepPhoneNumber: string
  vendorRepId: string
  active: boolean
  cutoffTime?: Date
  entries: IPriceListEntry[]
}

export class PriceList implements IPriceList {
  public id: string = uuid()
  public entries: PriceListEntry[] = []
  public vendorRepEmail: string = ''
  public vendorRepPhoneNumber: string = ''
  public vendorRepName: string = ''
  public vendorCompanyName: string = ''
  public vendorRepId: string = ''
  public active: boolean = false
  public cutoffTime?: Date

  constructor(
      public vendorCompanyId: string,
      public restaurantCompanyId: string
  ) {}

  public get vendorRepDisplayName() {
    return this.vendorRepName.split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
  }
}
